import Service from "../Service";

const resource = "othersupport/";

export default {
  list(uss, requestID) {
    return Service.post(resource + "userlist", uss, { params: { requestID } });
  },
  changePassword(uss, requestID) {
    return Service.post(resource + "changePassword", uss, { params: { requestID } });
  },
  exchangeRateList(requestID) {
    return Service.post(resource + "exchangeratelist", {}, { params: { requestID } });
  },
  exchangeRateListApi(requestID) {
    return Service.post(resource + "exchangeratelistApi", {}, { params: { requestID } });
  },
  exchangeRateSave(date, requestID) {
    return Service.post(resource + "exchangeratesave", {}, { params: { requestID, date } });
  },
  exchangeRateSaveApi(date, requestID) {
    return Service.post(resource + "exchangeratesaveApi", {}, { params: { requestID, date } });
  },
  exchangeratesap(Date, TypeCurrencyName, requestID) {
    return Service.post(resource + "exchangeratesap", {}, { params: { requestID, Date, TypeCurrencyName } });
  },
};
